import { render } from "./BlFormFieldRichtext.vue?vue&type=template&id=608bb7da&scoped=true"
import script from "./BlFormFieldRichtext.vue?vue&type=script&lang=js"
export * from "./BlFormFieldRichtext.vue?vue&type=script&lang=js"

import "./BlFormFieldRichtext.vue?vue&type=style&index=0&id=608bb7da&scoped=true&lang=scss"

import exportComponent from "/tmp/b7562a83-daa0-4796-bff7-c3f4922e39c8/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-608bb7da"]])

export default __exports__